import alertType from "../../actions/alert/alertType";
const initialState = {
  isShow: false,
  content: "",
  variant: "",
  isModal: false,
  background: "",
  showTime: 3000,
  maxWidth: "",
  backdrop: false,
  notCentered: false,
};

const alertReducer = (state = initialState, action) => {
  switch (action.type) {
    case alertType.SHOW_ALERT:
      return { ...state, isShow: true };
    case alertType.CLOSE_ALERT:
      return { ...state, isShow: false, isModal: false };
    case alertType.SHOW_SUCCESS_ALERT:
      return {
        ...state,
        isShow: true,
        isModal: false,
        content: action.content,
        background: "var(--success-color)",
      };
    case alertType.SHOW_DANGER_ALERT:
      return {
        ...state,
        isShow: true,
        isModal: false,
        content: action.content,
        background: "var(--danger-color)",
      };
    case alertType.SHOW_INFO_ALERT:
      return {
        ...state,
        isShow: true,
        isModal: false,
        content: action.content,
        background: "var(--tertiary-color)",
      };
    case alertType.SHOW_START_SIM_ALERT:
      return {
        ...state,
        isShow: true,
        isModal: false,
        content:
          "در صورتی که شبیه‌ساز را به درستی مشاهده نمی‌کنید، صفحه را مجدد بارگذاری کنید.",
        background: "var(--tertiary-color)",
        showTime: 15000, //15s
      };
    case alertType.SHOW_MODAL:
      return {
        ...state,
        isShow: true,
        content: action.content,
        isModal: true,
        background: "var(--bg-color)",
        maxWidth: action.maxWidth ? action.maxWidth : "470px",
        backdrop: action.backdrop ? action.backdrop : false,
        notCentered: action.notCentered ? action.notCentered : false,
      };

    default:
      return state;
  }
};

export default alertReducer;
